/* eslint-disable */
const SECURITY = {
  SECURITY_MANAGE_LIST_ROLECATEGORY: 'security/manage/list/roleCategory',
  SECURITY_MANAGE_LIST_ROLE: 'security/manage/list/role',
  SECURITY_MANAGE_LIST_PERMISSION: 'security/manage/list/permission',
  SECURITY_MANAGE_GET_ROLE: 'security/manage/get/role',
  SECURITY_MANAGE_EDIT_ROLE: 'security/manage/edit/role',
  SECURITY_REPORT_ROLE: 'security/report/role',
  SECURITY_MANAGE_ADD_ROLE: 'security/manage/add/role',
  SECURITY_MANAGE_DELETE_ROLE: 'security/manage/delete/role',
  SECURITY_MANAGE_EDIT_PERMISSION: 'security/manage/edit/permission'
}
export default SECURITY
